import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomEncoder } from 'app/modules-services/auth-services/authentication.service';
import { ForfettappApiClient } from 'app/shared/forfettapp-api-client';
import { BehaviorSubject, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Operatore, Ruolo } from './ruoli-operatori.models';

type Guid = string | null;

@Injectable({
    providedIn: 'root',
})
export class RuoliOperatoriService {
    private _ruoli = new BehaviorSubject<Ruolo[]>(null);
    private _operatori = new BehaviorSubject<Operatore[]>(null);

    constructor(private service: ForfettappApiClient) {}

    get ruoli$() {
        return this._ruoli.pipe(
            switchMap(ruoli => {
                if (ruoli === null) {
                    return this.getRuoli();
                } else {
                    return of(ruoli);
                }
            })
        );
    }

    get operatori$() {
        return this._operatori.pipe(
            switchMap(operatori => {
                if (operatori === null) {
                    return this.getOperatori();
                } else {
                    return of(operatori);
                }
            })
        );
    }

    getRuoli() {
        return this.service.get<Ruolo[]>(`/backoffice/ruoli`).pipe(
            tap(ruoli => {
                this._ruoli.next(ruoli);
            })
        );
    }

    rimuoviRuolo(operatoreId: Guid, ruolo: Ruolo) {
        return this.service.delete(`/backoffice/utente/${operatoreId}/roles/${ruolo.name}`).pipe(switchMap(() => this.getOperatori()));
    }

    aggiungiRuolo(operatoreId: Guid, ruolo: Ruolo) {
        return this.service.post(`/backoffice/utente/${operatoreId}/roles/${ruolo.name}`).pipe(switchMap(() => this.getOperatori()));
    }

    getOperatori() {
        return this.service.get<Operatore[]>(`/backoffice/utenti-ruoli`).pipe(
            tap(operatori => {
                this._operatori.next(operatori);
            })
        );
    }

    getRuoliOperatore(operatoreId: Guid) {
        return this.service.get<Ruolo[]>(`/backoffice/utente/${operatoreId}/roles`);
    }

    upsertOperatore(email: string, roles: Ruolo[]) {
        let params = new HttpParams({ encoder: new CustomEncoder() });
        params = params.append('email', email);
        return this.service.post(`/backoffice/utenti-ruoli/roles`, roles, params);
    }
}
